// Regras puras do menu lateral (Fase 17.8, Plano 10; D-17, D-25; UI-SPEC U-09).
// Sem DOM: o provider da sidebar e o indicador do item ativo chamam estas funções.

export type ModoMenu = 'sheet' | 'rail-sobreposto' | 'desktop';

/** Abaixo disto a navegação é o Sheet (drawer). */
export const LARGURA_MINIMA_TABLET = 768;
/** A partir daqui o menu é o do desktop e a escolha de recolher é lembrada. */
export const LARGURA_MINIMA_DESKTOP = 1280;
/** Altura de um item de nível 1 no desktop (UI-SPEC U-09). */
export const ALTURA_ITEM_MENU = 40;

/** < 768 sheet; 768 a 1279 rail que expande por cima do conteúdo; >= 1280 desktop. */
export function modoDoMenu(larguraJanela: number): ModoMenu {
  if (larguraJanela < LARGURA_MINIMA_TABLET) return 'sheet';
  if (larguraJanela < LARGURA_MINIMA_DESKTOP) return 'rail-sobreposto';
  return 'desktop';
}

/** O cookie `sidebar_state` só é lido e gravado no desktop; o tablet nunca contamina a preferência dele. */
export function deveGravarPreferencia(larguraJanela: number): boolean {
  return larguraJanela >= LARGURA_MINIMA_DESKTOP;
}

/** Deslocamento do indicador deslizante para o item de nível 1 de índice `indiceAtivo` (itens de altura fixa). */
export function deslocamentoIndicador(indiceAtivo: number, alturaItem: number = ALTURA_ITEM_MENU): string {
  const indice = Number.isFinite(indiceAtivo) && indiceAtivo > 0 ? indiceAtivo : 0;
  return `translateY(${indice * alturaItem}px)`;
}
